module.exports = __webpack_public_path__ + "static/media/S-task07_nodeLink.69f0ecbd.png";